import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import Root from "./root";

import Normalize from "react-normalize";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <Root>
      <Normalize />
      <App />
    </Root>
  </React.StrictMode>,
  document.getElementById("root")
);

// alert("An error has occurred, you have been logged out.");
// window.localStorage.clear(); //clear any saved state
// window.location.reload(); // reload page

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
